import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  loadingText: '',
};

export const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    setLoadingTrue: state => {
      state.loading = true;
    },
    setLoadingFalse: state => {
      state.loading = false;
      state.loadingText = '';
    },
    setLoadingWithText: (state, action) => {
      state.loading = true;
      state.loadingText = action.payload;
    },
  },
});

export const { setLoadingTrue, setLoadingFalse, setLoadingWithText } = loaderSlice.actions;

export default loaderSlice.reducer;
